
import Page from '@root/common/base/Page';
import GridSkeletonLoader from '@root/common/components/base/loader/GridSkeletonLoader.vue';
import AdsLayout from '@root/common/components/layout/AdsLayout.vue';

import { Data as TagsData } from '@root/modules/tags/types/tags';
import Tags from '@root/modules/tags/services/Tags.service';
import TagBreadcrumbs from '@root/modules/tags/components/TagBreadcrumbs.vue';
import TagFilter from '@root/modules/tags/components/TagFilter.vue';
import TagsList from '@root/modules/tags/components/TagsList.vue';
import PageHeader from '@root/common/components/base/PageHeader.vue';
import getFrontPageAdsSettings from '@root/modules/frontpage/utils/getFrontPageAdsSettings';
import isMobileView from '@root/common/utils/isMobileView';

interface Data {
  isMobileView: boolean;
  lang: string;
  tags: TagsData;
}

interface Methods {
  changePage: () => void;
  searchTag: (searchValue: string) => void;
}

interface Computed {
  disabledAdsList: string[];
}

export default Page.extend<Data, Methods, Computed, unknown>({
  components: {
    TagBreadcrumbs,
    TagFilter,
    TagsList,
    PageHeader,
    GridSkeletonLoader,
    AdsLayout,
  },
  data() {
    return {
      isMobileView: false,
      lang: this.$channelConfig('settings').locale.split('_')[0],
      tags: {
        items: [],
        pager: {
          offset: 0,
          limit: 100,
        },
      },
    };
  },
  computed: {
    disabledAdsList() {
      return this.$store.getters['adForm/getDisabledAdsList'];
    },
  },
  async fetch() {
    const page = this.$route.query.page as string;
    const searchString = this.$route.query.search as string;
    const { lang } = this.$channelConfig('settings');

    try {
      const limit = 50;
      const tagsService = new Tags({ req: this.$ssrContext?.req });
      const search = {
        field: 'name',
        value: `${searchString ? decodeURI(searchString) : lang !== 'ru' ? 'A' : ''}`,
      };

      const data = await tagsService.fetch({ limit, page, language: lang.toUpperCase(), search });

      this.tags.items = data?.tags?.items?.length ? data.tags.items : [];

      if (data?.tags?.pager) {
        this.tags.pager = data.tags.pager;
      }

      this.setPageAdsSettings(getFrontPageAdsSettings({ $channelConfig: this.$channelConfig }));
    } catch (e) {
      this.handlePageError(e);
    }
  },
  watch: {
    $route() {
      this.$fetch();
    },
  },
  mounted() {
    this.isMobileView = isMobileView();
  },
  methods: {
    changePage() {
      this.$fetch();
    },
    searchTag(searchValue) {
      this.$router.replace({ query: { search: searchValue } });
    },
  },
  head() {
    const meta = this.getPageMeta();
    const title: string = this.$t('tags.title') as string;
    meta.setTitle({ title });

    return {
      title: meta.title,
      meta: meta.data,
      link: meta.link,
    };
  },
});
